<template>
  <div class="ll-map-navigation-tool">
    <div
      class="ll-map-navigation-tool_reset"
      @click="$_resetClick()"
    >
      <i class="icon-zoom" />
    </div>
    <div class="ll-map-navigation-tool_zoom">
      <i
        class="icon-add ll-map-navigation-tool_zoom-icon"
        @click="$_zoomInClick()"
      />
      <div class="ll-map-navigation-tool_zoom-line" />
      <i
        class="icon-reduce ll-map-navigation-tool_zoom-icon"
        @click="$_zoomOutClick()"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlMapNavigationTool",
  methods: {
    $_zoomInClick() {
      this.$emit("zoom-in");
    },
    $_zoomOutClick() {
      this.$emit("zoom-out");
    },
    $_resetClick() {
      this.$emit("reset-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-map-navigation-tool";
</style>